import BaseAPI from '../base'

function createPayReceiver(data) {
    return BaseAPI.post(`/payment/payreceivers/create`, data);
}

function getPayReceivers(cafe_id) {
    return BaseAPI.get(`/payment/payreceivers/list/${cafe_id}`)
}

function removePayReceiver(id) {
    return BaseAPI.post(`/payment/payreceivers/remove/${id}`);
}

function updatePayReceiver(id, data) {
    return BaseAPI.post(`/payment/payreceivers/update/${id}`, data);
}

export default {
    createPayReceiver,
    getPayReceivers,
    removePayReceiver,
    updatePayReceiver
}